export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14199.b98603a8.jpg";